import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Pagination } from '../../models/pagination';
import { SweetMessage } from '../../config/sweet-message';
import { ConfigService } from '../../config/config-service';
import { SessionService } from '../../services/session.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { BsModalService} from 'ngx-bootstrap/modal';
import { UsuarioRestriccion } from '../../models/usuario_restriccion';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UsuarioRestriccionService } from '../../services/usuario-restriccion.service';

@Component({
	selector: 'grid',
	templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.css'],
    providers: [UsuarioRestriccionService]
})
export class GridComponent implements OnInit {
    @Input() dataGrid: any;

    public arrayData: Array<any>;
    public pagination: Pagination;
    public msg: SweetMessage;
    private config: ConfigService;
    private q: Array<any>;
    public loading = false;

    //Restriccion de usuarios
    //parte no generica
    private idData: String;
    private cadena:String;
    public bsModalRef: BsModalRef;
    private showForm: Boolean;
    private dataComplete: Array<any>;
    private usuarioRestriccion: UsuarioRestriccion; 
    private myForm: FormGroup;


	constructor(
        private http: Http,
        private NavRoute: Router,
        private storage: AsyncLocalStorage,
        private ss: SessionService,
        private modalService: BsModalService,
        private fb: FormBuilder,
        private usuarioRestriccionService: UsuarioRestriccionService
        
    ) {
        this.pagination = new Pagination();
        this.msg = new SweetMessage();
        this.config = new ConfigService();
        this.q = [];

        
    }

	ngOnInit() {
        this.dataGrid.columsDef.forEach(e => e.Searchable ? this.q[e.Field]='' : false );
        this.loading = true;
        this.getData().then(
            res => this.loading = false,
            err => this.loading = false
        );

        //Restriccion de usuarios
        this.onFormRestriccion();
        this.usuarioRestriccion = new UsuarioRestriccion();
    }

    getData(){
        return new Promise((resolve, reject) => {
            let url = this.ss.getData('host_api') + this.dataGrid.endPoint.toString();
            //this.loading = true;
            let headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Authorization", "Bearer " + this.ss.getData('api-token'));
            headers.append("dbname", this.ss.getData('dbname'));
            let options = new RequestOptions({ headers: headers });

            let qs = this.dataGrid.qs || "";
            let qd = "";
            
            for(let key in this.q){
                qd = qd + "&q["+key+"]="+this.q[key];
            }
            
            let queryString = '?page=' + this.pagination.current_page + '&per_page=' + this.dataGrid.perPage + qs + qd;

            let response = this.http.get(url + queryString, options).map(res => res.json());

            response.subscribe(
                res => {
                    //this.loading = false;
                    if( res.data ){
                        this.arrayData = res.data;

                        // Paginación
                        this.pagination.current_page = res.current_page;
                        this.pagination.from = res.from;
                        this.pagination.to = res.to;
                        this.pagination.total = res.total;
                        this.pagination.last_page = res.last_page;
                        this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
                        this.pagination.prev_disabled = this.pagination.current_page === 1;
                    }else{
                        this.arrayData = [];
                    }
                    resolve();
                },
                err => {
                    //this.loading = false;
                    this.arrayData = [];
                    reject(err);
                }
            );
        });
    }

    onEdit(data) {
		this.storage.setItem(this.dataGrid.keyGrid.toString(), data).subscribe(() => {
			this.NavRoute.navigate([this.dataGrid.routeEdit]);
		});
    }
    
    onDelete(id){
		this.msg.showMessage('delete-confirm-message').then(
			res => {
                if(res == "ok"){
                    let url = this.ss.getData('host_api') + this.dataGrid.endPoint.toString()+'/'+id+'/del';
                    let params = {usuario_id: this.ss.getData('usuario_id')};
                    let headers = new Headers();
                    headers.append("Accept", "application/json");
                    headers.append("Authorization", "Bearer " + this.ss.getData('api-token'));
                    headers.append("dbname", this.ss.getData('dbname'));
                    let options = new RequestOptions({ headers: headers });

                    this.loading = true;
                    let response = this.http.put(url, params, options).map((res:Response) => {
                        return this.config.onSuccessResponse(res);
                    }).catch((error: any) => {
                        return this.config.onErrorResponse(error);
                    });

                    response.subscribe(
                        res => {
							//if(res.message){
                            this.getData().then(
                                () => {
                                    this.msg.showMessage('success-message',res.message);
                                    this.loading = false;
                                },
                                err => this.loading = false
                            );
							//}
						},
						err => {
                            this.loading = false;
							this.msg.showMessage('error-message', err);
						}
                    );
                }
            }
		);
    }
    
    showColumn(colum, dataColum){
        let arrayColum = colum.Field.split('.');

        for(let key in arrayColum){
            let i = arrayColum[key];

            if( colum.mask ){
                dataColum = dataColum[i];
            }else{
                if( !dataColum[i] ){
                    dataColum = "-";
                    break;
                }else{
                    dataColum = dataColum[i];
                }
            }
        }
        let data = dataColum;

        if( colum.mask ){
            data = colum.mask(data);
        }
        return data;
    }
    
    next(){
        this.pagination.current_page++;
        this.loading = true;
		this.getData().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	prev(){
        this.pagination.current_page--;
        this.loading = true;
		this.getData().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	first(){
        this.pagination.current_page = 1;
        this.loading = true;
		this.getData().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	last(){
        this.pagination.current_page = this.pagination.last_page;
        this.loading = true;
		this.getData().then(
            res => this.loading = false,
            err => this.loading = false
        );
    }
    
    searchHeader(field, text){
        this.q[field] = text;
        this.pagination.current_page = 1;
        this.loading = true;
        this.getData().then(
            res => this.loading = false,
            err => this.loading = false
        );
    }

    getIndexNumber(i){
        return this.pagination.from+i;
    }


    //Parte de restriccion de usuario, no generica
    onModal(modalTemplate: TemplateRef<any>,data){
        this.idData = data.id;
        this.dataComplete = data;

        if(data.horario_restringido){
            this.showForm = data.horario_restringido;

            this.myForm.setValue({
                hora_desde: data.usuariorestriccion[0].hora_desde,
                hora_hasta: data.usuariorestriccion[0].hora_hasta
            });
        }else{
            this.myForm.setValue({
                hora_desde: "",
                hora_hasta: ""
            });
        }
        

        this.bsModalRef = this.modalService.show(modalTemplate);
    }

    onShowForm(){
        this.showForm = !this.showForm;
    }

    resetShowForm(){
        this.showForm = false;
    }

    onFormRestriccion(){
        this.myForm = this.fb.group({
            hora_desde: ['',[Validators.required, Validators.pattern(/^([0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)]],
            hora_hasta: ['',[Validators.required, Validators.pattern(/^([0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)]]
        });
    }

    onSubmit(){
        this.setValuesFormRestriccion()
        this.usuarioRestriccionService.save(this.usuarioRestriccion).subscribe(
            res => {
                this.msg.showMessage('success-message', res.message);
                this.usuarioRestriccion = new UsuarioRestriccion();
                this.onFormRestriccion();

                this.loading = true;
                this.getData().then(
                    res => this.loading = false,
                    err => this.loading = false
                );
            },
            err => {
                this.msg.showMessage('error-message', err);
            }
        );
    }

    setValuesFormRestriccion(){       
        this.usuarioRestriccion.hora_desde = this.myForm.controls['hora_desde'].value;
        this.usuarioRestriccion.hora_hasta = this.myForm.controls['hora_hasta'].value;
        this.usuarioRestriccion.usuario_id_restriccion = this.idData;
        this.usuarioRestriccion.usuario_id = this.ss.getData('usuario_id');
        this.usuarioRestriccion.empresa_id = this.ss.getData('empresa_id');
    }

    isValidForm(){
        if( !this.myForm.controls['hora_desde'].value ){
			return false;
		}
		if( !this.myForm.controls['hora_hasta'].value ){
			return false;
        }

        return true;
    }

    actualizaRestriccion(){
        if(!this.showForm){
            this.usuarioRestriccionService.update(this.idData).subscribe(
                res => {
                    this.msg.showMessage('success-message', res.message);
                    this.usuarioRestriccion = new UsuarioRestriccion();
                    this.onFormRestriccion();
                    
                    this.loading = true;
                    this.getData().then(
                        res => this.loading = false,
                        err => this.loading = false
                    );
                },
                err => {
                    this.msg.showMessage('error-message', err);
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/grid/grid.component.ts